module.exports = __webpack_public_path__ + "static/media/YM60_2.805d2033.jpg";